export var phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,10}$/;
export var specialChar = /[\$\%\#\@\!\^\&\*\(\)\)\+\"\'\;\)\\\/]/;
export var pswRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\S]{8,}$/;
export var onlySpacesRegExp = /^(?!\s+$).*/;
export var vatCodeRegExp1 = /^(.(?!([0-9A-Za-z\-]{5,100})))*$/gi;
export var vatCodeRegExp = /[0-9A-Za-z\-]{5,100}/gi;
export var phoneRegExpInput = /[0-9]/g;
